/**
 * @fileoverview Configures and exports AI language models with Awolf settings using `withAwolfSettings`. Defines and exports various models like `ClaudeSonnetModel`, `Gpt4oModel`, and `Gemini20FlashModel`, and provides a `models` map for easy access. `DefaultModel` is also exported.
 */

import {
  ClaudeHaikuModel as ClaudeHaiku,
  ClaudeSonnetModel as ClaudeSonnet,
} from '@iterator/shared-node/ai/anthropic'
import {
  Llama_33_70B_n1_multiLine,
  Llama_33_70B_n1_singleLine,
  Llama_33_70B_n4_singleLine,
  Deepseek_R1,
  Deepseek_V3,
  Llama_4_Scout,
  Llama_4_Maverick,
} from '@iterator/shared-node/ai/fireworks'
import { Model, ModelNeedingKeys } from '@iterator/shared-node/ai/llm_types'
import { AwolfSettings } from '@src/settings'
import { Gemini20Flash, Gemini20FlashThinking } from '@iterator/shared-node/ai/google'
import {
  Gpt5Model as Gpt5,
  Gpt4oModel as Gpt4o,
  Gpt4oMiniModel as Gpt4oMini,
  Gpt41Model as Gpt41,
} from '@iterator/shared-node/ai/openai'
function withAwolfSettings(model: ModelNeedingKeys): Model {
  return {
    ...model,
    getApi: () => model.getApi(AwolfSettings.singleton()),
  }
}

export const ClaudeSonnetModel = withAwolfSettings(ClaudeSonnet)
export const ClaudeHaikuModel = withAwolfSettings(ClaudeHaiku)
export const Llama_4_Scout_Model = withAwolfSettings(Llama_4_Scout)
export const Llama_4_Maverick_Model = withAwolfSettings(Llama_4_Maverick)
export const Llama_33_70B_n1_multiLine_Model = withAwolfSettings(Llama_33_70B_n1_multiLine)
export const Llama_33_70B_n1_singleLine_Model = withAwolfSettings(Llama_33_70B_n1_singleLine)
export const Llama_33_70B_n4_singleLine_Model = withAwolfSettings(Llama_33_70B_n4_singleLine)
export const Deepseek_R1_Model = withAwolfSettings(Deepseek_R1)
export const Deepseek_V3_Model = withAwolfSettings(Deepseek_V3)
export const Gpt5Model = withAwolfSettings(Gpt5)
export const Gpt41Model = withAwolfSettings(Gpt41)
export const Gpt4oModel = withAwolfSettings(Gpt4o)
export const Gpt4oMiniModel = withAwolfSettings(Gpt4oMini)
export const Gemini20FlashModel = withAwolfSettings(Gemini20Flash)
export const Gemini20FlashThinkingModel = withAwolfSettings(Gemini20FlashThinking)

export const models: Record<string, Model> = {
  [Gpt5Model.name]: Gpt5Model,
  [Gpt4oModel.name]: Gpt4oModel,
  [Gpt4oMiniModel.name]: Gpt4oMiniModel,
  [Gpt41Model.name]: Gpt41Model,
  [ClaudeSonnetModel.name]: ClaudeSonnetModel,
  [ClaudeHaikuModel.name]: ClaudeHaikuModel,
  [Gemini20FlashModel.name]: Gemini20FlashModel,
  [Gemini20FlashThinkingModel.name]: Gemini20FlashThinkingModel,
  [Deepseek_R1_Model.name]: Deepseek_R1_Model,
  [Deepseek_V3_Model.name]: Deepseek_V3_Model,
}
export const DefaultModel = Gemini20FlashModel
